import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-zhenai_home_sel",
  "use": "icon-zhenai_home_sel-usage",
  "viewBox": "0 0 26 26",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 26 26\" id=\"icon-zhenai_home_sel\"><g stroke-width=\"1.5\" fill=\"none\" fill-rule=\"evenodd\"><path stroke=\"#996EF0\" stroke-linejoin=\"round\" d=\"m5 10 8-6 8 6v12H5z\" /><path d=\"M9.783 16.784C10.513 17.522 11.682 18 13 18s2.488-.478 3.217-1.216\" stroke=\"#FFAB11\" stroke-linecap=\"round\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol